var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { LitElement } from "@horizon/base";
import { property } from "@horizon/base/decorators.js";
import { classMap } from "@horizon/base/directives";
import { unsafeStatic, html } from "@horizon/base/static-html.js";
import HeadingStyles from "./heading.css.js";
import { headingTags } from "../types.js";
class HznHeading extends LitElement {
  constructor() {
    super(...arguments);
    this.align = "left";
    this.as = "h2";
    this.tone = "brand";
    this.size = "medium";
    this.lineHeight = "base";
    this.static = false;
  }
  render() {
    return html`<${unsafeStatic(this.as && headingTags.includes(this.as) ? this.as : "h2")}
      class=${classMap({
      heading: true,
      "is-static": Boolean(this.static),
      "is-align-left": this.align === "left",
      "is-align-center": this.align === "center",
      "is-align-right": this.align === "right",
      "is-tone-brand": this.tone === "brand",
      "is-tone-brand-accent": this.tone === "brand-accent",
      "is-tone-inverse": this.tone === "inverse",
      "is-tone-neutral": this.tone === "neutral",
      "is-tone-subdued": this.tone === "subdued",
      "is-size-xsmall": this.size === "xsmall",
      "is-size-small": this.size === "small",
      "is-size-medium": this.size === "medium",
      "is-size-large": this.size === "large",
      "is-size-xlarge": this.size === "xlarge",
      "is-size-xxlarge": this.size === "xxlarge",
      "is-lineheight-none": this.lineHeight === "none",
      "is-lineheight-xsmall": this.lineHeight === "xsmall",
      "is-lineheight-small": this.lineHeight === "small",
      "is-lineheight-base": this.lineHeight === "base",
      "is-lineheight-large": this.lineHeight === "large",
      "is-lineheight-xlarge": this.lineHeight === "xlarge",
      "is-on-brand": this.on === "brand",
      "is-on-brand-accent": this.on === "brand-accent"
    })}>
        <slot></slot>
    </${unsafeStatic(this.as && headingTags.includes(this.as) ? this.as : "h2")}>`;
  }
}
HznHeading.styles = [HeadingStyles];
__decorateClass([
  property({ type: String })
], HznHeading.prototype, "align", 2);
__decorateClass([
  property({ type: String })
], HznHeading.prototype, "as", 2);
__decorateClass([
  property({ type: String })
], HznHeading.prototype, "tone", 2);
__decorateClass([
  property({ type: String })
], HznHeading.prototype, "size", 2);
__decorateClass([
  property({ type: String, attribute: "line-height" })
], HznHeading.prototype, "lineHeight", 2);
__decorateClass([
  property({ type: String })
], HznHeading.prototype, "on", 2);
__decorateClass([
  property({ type: Boolean })
], HznHeading.prototype, "static", 2);
export {
  HznHeading
};
//# sourceMappingURL=heading.js.map
